export const eventsRoutes = {
  path: '/events',
  children: [
    {
      name: 'events',
      path: '',
      component: () => import('pages/Events/Events/index.vue'),
      meta: {
        title: 'Events',
      },
    },
    {
      name: 'newEvent',
      path: 'new',
      component: () => import('pages/Events/NewEvent/index.vue'),
      meta: {
        title: 'New Event',
      },
    },
    {
      name: 'editEvent',
      path: ':id/edit',
      component: () => import('pages/Events/EditEvent/index.vue'),
      meta: {
        title: 'Edit Event',
      },
    },
  ],
}
